import styles from "./carol.module.scss";

const Carol = () => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.image}></div>
			<div className={styles.inside}>
				<h1>WIZYTA DUSZPASTERSKA</h1>
				<h3>1 grudnia (NIEDZIELA) 2024 roku, ulica Gibałówka.</h3>
<p><span>Rozpoczęcie o godzinie 16.30.</span> Od Państwa Karoliny i Daniela Borowiec, zakończenie u Państwa Zbigniewa i Edyty Gaczoł.</p>

<h3>1 grudnia (NIEDZIELA) 2024 roku, ulica Wspólna.</h3>
<p><span>Rozpoczęcie o godzinie 18.30.</span> Od Państwa Tomasza i Magdaleny Grzesik, zakończenie u Państwa Kazimierza i Grażyny Włudyków.</p>

<h3>7 grudnia (SOBOTA) 2024 roku, ulica Parafialna.</h3>
<p><span>Rozpoczęcie o godzinie 9.00.</span> Od Pana Przemysława Łagosza, zakończenie u Państwa Stanisława i Ewy Bernady, koło sklepu Biedronka.</p>

<h3>14 grudnia (SOBOTA) 2024, ulica Wiślana i Ludowa.</h3>
<p><span>Rozpoczęcie o godzinie 9.00.</span> Od Pana Władysława Szydłowskiego, zakończenie u Państwa Norberta i Małgorzaty Kubiczek.</p>

<h3>15 grudnia (NIEDZIELA) 2024, ulica Wiślana.</h3>
<p><span>Rozpoczęcie o godzinie 16.30.</span> Od Państwa Sebastiana i Nikoli Franczyk, zakończenie u Państwa Wojciecha i Wiolety Nowak przy rondzie.</p>

<h3>22 grudnia (NIEDZIELA) 2024, ulica Na Stoku.</h3>
<p><span>Rozpoczęcie o godzinie 16.30.</span> Od Państwa Artura i Zofii Król, zakończenie u Państwa Maksymiliana i Justyny Chmielarzów.</p>

<h3>28 grudnia (SOBOTA) 2024, ulica Januszowska.</h3>
<p><span>Rozpoczęcie o godzinie 9.00.</span> Od Państwa Łukasza i Katarzyny Martyków, zakończenie u Państwa Józefa i Doroty Wąsik.</p>

<h3>29 grudnia (NIEDZIELA) 2024, ulica Jeziorańska.</h3>
<p><span>Rozpoczęcie o godzinie 17.30.</span> Od Państwa Grzegorza i Doroty Kwiatek, zakończenie u Państwa Michała i Karoliny Koczwarów.</p>

<h3>30 grudnia (PONIEDZIAŁEK) 2024, ulica Jana Kantego.</h3>
<p><span>Rozpoczęcie o godzinie 16.00.</span> Od Państwa Grzegorza i Anny Baniak, zakończenie u Pani Moniki Rudnik.</p>

<h3>4 Styczeń (SOBOTA) 2025, ulica Stanisławska.</h3>
<p><span>Rozpoczęcie o godzinie 9.00.</span> Od Państwa Zenona i Grażyny Kubala, zakończenie u Państwa Stanisława i Barbary Wyczesany.</p>

<h3>5 Styczeń (NIEDZIELA) 2025, ulica Leśny Stok.</h3>
<p><span>Rozpoczęcie o godzinie 16.30</span> Od Państwa Marka i Marzeny Blum, zakończenie u Państwa Bartłomieja i Anny Tabaszowskich.</p>

<h3>6 Styczeń (PONIEDZIAŁEK) 2025, ulica Osiedle Szkolne.</h3>
<p><span>Rozpoczęcie o godzinie 16.30</span> Od Państwa Jacka i Jolanty Szczygiełek, zakończenie u Państwa Dawida i Iwony Halik.</p>

<h3>7 Styczeń (WTOREK) 2025, ulica Siostry Katarzyny Przybytniak.</h3>
<p><span>Rozpoczęcie o godzinie 16.00</span> Od Państwa Marka i Elżbiety Mularz, zakończenie u Państwa Mariusza i Agnieszki Stolarz.</p>

<h3>9 Styczeń (CZWARTEK) 2025, ulica Niwa.</h3>
<p><span>Rozpoczęcie o godzinie 16.00</span> Od Pani Zofii Wszołek, zakończenie u Pani Haliny Kuciel.</p>

<h3>12 Styczeń (NIEDZIELA) 2025, ulica TRAKT KRÓLEWSKI. TYLKO PRAWA STRONA OD SKLEPU CENTRUM</h3>
<p><span>Rozpoczęcie o godzinie 16.30</span> Od Państwa Dawida i Pauliny Gicala, zakończenie u Państwa Tadeusza i Anny Pasierb.</p>

<h3>13 Styczeń (PONIEDZIAŁEK) 2025, ulica Dobrego Pasterza.</h3>
<p><span>Rozpoczęcie o godzinie 16.00</span> Od Państwa Grzegorza i Marii Kaczmarzyk, zakończenie u Państwa Marcina i Krystyny Pawlik.</p>

<h3>14 Styczeń (WTOREK) 2025, ulica Dobrego Pasterza</h3>
<p><span>Rozpoczęcie o godzinie 16.00</span> Od Państwa Artura i Moniki Latocha, zakończenie u Państwa Marka i Joanny Niedźwieckich.</p>

<h3>16 Styczeń (CZWARTEK) 2025, ulica Kościelna tylko prawa strona od wjazdu od ulicy Wiślanej.</h3>
<p><span>Rozpoczęcie o godzinie 16.00</span> Rozpoczęcie o godzinie 16.00. Od Pani Marii Witkowskiej, zakończenie u Państwa Piotra i Marty Wąsik.</p>

<h3>18 Styczeń (SOBOTA) 2025, ulica Kościelna tylko lewa strona od Przedszkola Parafialnego</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Od Pana Ryszarda Zachary, zakończenie u Państwa Tomasza i Renaty Pasierb.</p>

<h3>19 Styczeń (NIEDZIELA) 2025, ulica Kościelna tylko prawa strona od wjazdu od ulicy Wiślanej.</h3>
<p><span>Rozpoczęcie o godzinie 16.30</span> Od Pani Danuty Pietras, zakończenie u Państwa Bolesława i Doroty Kazek.</p>

<h3>20 Styczeń (PONIEDZIAŁEK) 2025, ulica Stolarska</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Od Państwa Dariusza i Anny Robak, zakończenie u Państwa Józefa i Katarzyny Gicala.</p>

<h3>21 Styczeń (WTOREK) 2025, ulica Siostry Faustyny od strony Bucza</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Od Państwa Dominika i Alicji Szkarłat, zakończenie u Państwa Damiana i Beaty Kazek.</p>

<h3>23 Styczeń (CZWARTEK) 2025, ulica Siostry Faustyny od strony Bucza</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Od Państwa Sebastiana i Ewy Korygi, zakończenie u Państwa Wiesława i Małgorzaty Bober.</p>

<h3>25 Styczeń (SOBOTA) 2025, ulica Siostry Faustyny</h3>
<p><span>Rozpoczęcie o godzinie 15.00</span> Od Państwa Leszka i Renaty Pakuła, zakończenie u Państwa Marka i Jadwigi Adamczyk.</p>

<h3>26 Styczeń (NIEDZIELA) 2025, ulica TRAKT KRÓLEWSKI. TYLKO PRAWA STRONA OD SKLEPU CENTRUM</h3>
<p><span>Rozpoczęcie o godzinie 16.30</span> Od Państwa Stanisława i Ewy Latochów, zakończenie u Państwa Marcina i Moniki Grodny.</p>

<h3>27 Styczeń (PONIEDZIAŁEK) 2025, ulica TRAKT KRÓLEWSKI. TYLKO PRAWA STRONA OD SKLEPU CENTRUM</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Od Państwa Jana i Jadwigi Szkodny, zakończenie u Państwa Tomasza i Dagmary Matras.</p>

<h3>8 Lutego (SOBOTA) 2025, ulica SĄSIEDZKA I ZARZECZE</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Rozpoczęcie o godzinie 9.00. Od Pani Katarzyny Kielan, zakończenie u Państwa Tomasza i Pauliny Biedak.</p>

<h3>15 Lutego (SOBOTA) 2025, ulica TRAKT KRÓLEWSKI. TYLKO LEWA STRONA OD SKLEPU CENTRUM</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Rozpoczęcie o godzinie 9.00. Od Pana Stanisława Koczwary, zakończenie u Państwa Daniela i Moniki Klimek.</p>

<h3>22 Lutego (SOBOTA) 2025, ulica TRAKT KRÓLEWSKI ORAZ ULICA WERONIKI PAŁACH. TYLKO LEWA STRONA OD SKLEPU CENTRUM</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Od Państwa Marka i Agnieszki Sobol, zakończenie u Państwa Bolesława i Wilhelminy Bocian.</p>

<h3>01 Marzec (SOBOTA) 2025, ulica Gminna i Potokowa.</h3>
<p><span>Rozpoczęcie o godzinie 9.00</span> Od Państwa Małgorzaty i Roberta Motak, zakończenie u Państwa Michała i Katarzyny Dziedzic.</p>


			</div>
		</div>
	);
};

export default Carol;
